// Core
import React from 'react';
import { Link } from 'react-router-dom';

import css from './style.scss';

class Header extends React.Component {

  render() {
    return (
      <header className={ css.Header }>
        <p className={ css.p }>
          <Link to="/" className={ css.backHome }>Pete Rugh</Link>
        </p>
        <nav>
          <ul>
            <li className={ css.li }>
              <Link to="/" className={ css.link }>Home</Link>
            </li>
            <li className={ css.li }>
              <Link to="/work" className={ css.link }>Work</Link>
            </li>
            <li className={ css.li }>
              <Link to="/skills" className={ css.link }>Skills</Link>
            </li>
          </ul>
        </nav>
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/js/components/Header/index.js